import type { PopoverProps } from '@byecode/ui'
import { Popover } from '@byecode/ui'
import type { BackgroundNoImageProtocol, BackgroundType } from '@lighthouse/core'
import { BACKGROUND_TYPE } from '@lighthouse/core'
import { FilledInput, FillPickerPopoverDropdown } from '@lighthouse/shared'
import isDeepEqual from 'fast-deep-equal'
import React from 'react'

import { useColorSystemAction } from '@/hooks/useColorSystemAction'
import { useGetColorVariableOptions } from '@/hooks/useGetColorVariableOptions'

interface FillColorProps {
    prefixPath?: string
    label?: string
    value: BackgroundNoImageProtocol | undefined
    onChange: (val: BackgroundNoImageProtocol) => void
    enabledBackgroundTypes?: BackgroundType[]
    onSetBreakKey?: (name: string) => void

    offsetOptions?: PopoverProps['offsetOptions']
}

const defaultBackgroundTypes: BackgroundType[] = [BACKGROUND_TYPE.color, BACKGROUND_TYPE.gradient /* , BACKGROUND_TYPE.variable */]

export const FillColor: React.FC<FillColorProps> = ({
    label = '填充',
    enabledBackgroundTypes = defaultBackgroundTypes,
    value,
    onChange,
    offsetOptions = 168
}) => {
    const colorSystemMethods = useColorSystemAction()

    const variableTypeOption = useGetColorVariableOptions()

    return (
        <Popover width={300} withinPortal position="left-start" autoUpdate={false} offsetOptions={offsetOptions}>
            <Popover.Target>
                <FilledInput
                    style={{ width: 180 }}
                    value={value}
                    onClear={() => {
                        onChange({ type: BACKGROUND_TYPE.color })
                    }}
                    variableTypeOption={variableTypeOption}
                />
            </Popover.Target>
            <FillPickerPopoverDropdown
                title={label}
                value={value}
                onChange={val => {
                    if (isDeepEqual(val, value)) {
                        return
                    }
                    onChange?.(val as BackgroundNoImageProtocol)
                }}
                enabledBackgroundTypes={enabledBackgroundTypes}
                variableTypeOption={variableTypeOption}
                {...colorSystemMethods}
            />
        </Popover>
    )
}
